import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {NgIf} from '@angular/common';
import {MAT_SNACK_BAR_DATA, MatSnackBarRef} from '@angular/material/snack-bar';

/** What the meeting reminder toast shows: the meeting, when it starts, and whether it has a Meet room to join. */
export interface CalendarReminderToastData {
  title: string;
  /** "starts in 10 min", or "is starting now" once its start has come. */
  when: string;
  canJoin: boolean;
}

/**
 * ITP-E-337-05 (Plan ITP-P-73, story 14) — "<title> starts in 10 min" with Join and Dismiss, opened by CalendarReminderService
 * with MatSnackBar.openFromComponent. Join is the snack bar's action (dismissWithAction), so the service, which knows the
 * room, navigates; Dismiss closes it. Join shows only for a meeting with a Meet.
 *
 * The snack bar's overlay lives outside every component, so encapsulation is None and every rule sits under the panel class.
 * The colours read the theme slots, so 2.0 dark paints it dark. It adds no motion: the snack bar's own enter and exit are
 * Material's, which it drops under prefers-reduced-motion.
 */
@Component({
  selector: 'app-calendar-reminder-toast',
  standalone: true,
  imports: [NgIf],
  templateUrl: './calendar-reminder-toast.component.html',
  styleUrls: ['./calendar-reminder-toast.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalendarReminderToastComponent {
  /** The snack bar's panel class, which scopes this component's styles. */
  static readonly panelClass = 'calendar-reminder-toast-panel';

  constructor(private snackBarRef: MatSnackBarRef<CalendarReminderToastComponent>,
              @Inject(MAT_SNACK_BAR_DATA) public data: CalendarReminderToastData) {
  }

  join(): void {
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
